__turbopack_context__.v({
  "className": "snippet_8ee96e74-module__AfzvqG__className",
});
